export const COLUMN_WIDTH = { base: '180px', md: '280px' };

export const ADJUSTABLE_PRICE_FIELD_HEIGHT = '110px';
export const ADJUSTABLE_PRICE_FIELD_HEIGHT_MOBILE = '130px';
export const COMPARABLE_FIELD_HEIGHT = '90px';
